import React from "react";
import { Info } from "lucide-react";

const BetaModelBanner = ({
  message = "You are trying NKENNEAi's BETA models. You will be charged from your token balance."
}) => {
  return (
    <div className="bg-[#FFF8EB] border border-[#FFE7C1] rounded-2xl p-4 flex items-center gap-3">
      <Info className="w-5 h-5 text-[#EF8702] flex-shrink-0" />
      <p className="text-gray-800 text-sm font-medium leading-relaxed">
        {message}
      </p>
    </div>
  );
};

export default BetaModelBanner;
